import { getApiErrorMessage } from '@/shared/utils/handleApiError';

const FORBIDDEN_MESSAGE =
  'Você não tem permissão para acessar a minuta de cálculo desta carga.';

const STATUS_MESSAGES = {
  401: FORBIDDEN_MESSAGE,
  403: FORBIDDEN_MESSAGE,
  404: 'Carga não encontrada.',
  422: 'Esta carga não possui cálculo de frete gerado.',
};

const FETCH_FALLBACK = 'Não foi possível carregar a minuta de cálculo.';
const FETCH_OFFLINE =
  'O servidor não respondeu ao carregar a minuta de cálculo. Tente novamente.';

const PRINT_FALLBACK = 'Não foi possível gerar o PDF da minuta.';
const PRINT_OFFLINE =
  'A geração do PDF não respondeu. Os dados exibidos acima continuam válidos ' +
  'para conferência; tente gerar novamente.';

export const MISSING_SHIPMENT_MESSAGE =
  'Carga não identificada. Feche a minuta e abra novamente pela listagem.';

const MIN_BACKEND_MESSAGE_LENGTH = 12;

function pickBackendMessage(error, fallbackMessage) {
  const message = getApiErrorMessage(error, fallbackMessage);

  if (!message || message.length < MIN_BACKEND_MESSAGE_LENGTH) return null;

  return message;
}

function describe(error, fallbackMessage, offlineMessage) {
  const response = error && error.response;

  if (!response) return offlineMessage;

  const status = Number(response.status);

  if (status === 401 || status === 403) return FORBIDDEN_MESSAGE;

  const data = response.data;

  if (data && data.message) {
    const message = pickBackendMessage(error, fallbackMessage);
    if (message) return message;
  }

  return STATUS_MESSAGES[status] || fallbackMessage;
}

export function describeFetchError(error) {
  return describe(error, FETCH_FALLBACK, FETCH_OFFLINE);
}

export function describePrintError(error) {
  return describe(error, PRINT_FALLBACK, PRINT_OFFLINE);
}
